import React, { useEffect, useState } from 'react';
import MobileProductCategoryTabs from '../mobileComponents/mobileAllProducts/MobileProductCategoryTabs';
import MobileProductSection from '../mobileComponents/mobileProductCard/MobileProductSection';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Divider, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { fetchCategories } from '../../store/category/action';

function MobileAllProducts() {
    const [currentProductCategory, setCurrentProductCategory] = useState('apparel');
    const [selectedCategory, setSelectedCategory] = useState([]);
    const productCategories = useSelector((state) => state.Category?.categories);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');

    useEffect(() => {
        if (!productCategories?.length) {
            dispatch(fetchCategories());
        }

        if (location?.pathname === '/card-list' && location?.search === '') {
            navigate('/card-list?category=apparel');
        }

        setCurrentProductCategory(categoryParam);
        const filteredData = productCategories?.filter(item => item?.slug === categoryParam);
        setSelectedCategory(filteredData?.[0]?.products);
    }, [location.search, productCategories]);

    return (
        <>
            <Helmet>
                <title>Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!</title>
                <meta name="description" content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion" />
                <meta property="og:title" content="Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!" />
                <meta property="og:description" content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion" />
            </Helmet>

            <Container disableGutters>
                <MobileProductCategoryTabs currentProductCategory={currentProductCategory} />
                <Divider />
                <MobileProductSection products={selectedCategory} />
            </Container>
        </>
    );
}

export default MobileAllProducts;
